export enum ELM4GeschaeftsFahrzeugAussendienstBerechnungsArt {
    EFFEKTIVE_BERECHNUNG = 'EFFEKTIVE_BERECHNUNG',
    ESTV_LISTE = 'ESTV_LISTE',
    VORABBESCHEID_STEUERVERWALTUNG = 'VORABBESCHEID_STEUERVERWALTUNG',
}
